import { request } from "../utils/request.js"


export const dataDictItem_findByPage = (pojo, args) => request({
    url: 'dataDictItem/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dataDictItem_findById = (id, args) => request({
    url: 'dataDictItem/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const dataDictItem_addNew = (pojo, args) => request({
    url: 'dataDictItem/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDictItem_update = (pojo, args) => request({
    url: 'dataDictItem/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDictItem_deleteById = (id, args) => request({
    url: 'dataDictItem/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDictItem_changeFrozenStatus = (id, args) => request({
    url: 'dataDictItem/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/dataDictItem.js